import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useTheme } from 'styled-components';
import { DropdownOptions, Flex, FormProvider, H, Text, TooltipPopup } from 'dash-ui';

import AuthenticationPageLayout from 'flow-components/AuthenticationPageLayout/AuthenticationPageLayout';
import renderBranch from 'common/helpers/renderBranch';

import { useGetAccountBySignUpVerificationCodeQuery } from 'gql/generated.graphql';

import SignUpForm from './components/SignUpForm';
import { FormFieldsList } from './components/SignUpForm/constants';
import InvitationExpiredForm from './components/InvitationExpiredForm';

function SignUpPage() {
  const { t } = useTranslation('pages', {
    keyPrefix: 'organizationSignUpPage',
  });
  const { t: tExpired } = useTranslation('pages', {
    keyPrefix: 'organizationSignUpExpiredPage',
  });
  const theme = useTheme();

  const { code = '' } = useParams();

  const { data, loading, error } = useGetAccountBySignUpVerificationCodeQuery({
    variables: {
      signUpVerificationCode: code || '',
    },
  });

  return renderBranch(
    loading,
    null,
    <AuthenticationPageLayout>
      <DropdownOptions />
      <TooltipPopup />
      <Flex flexDirection="column" w={334}>
        {renderBranch(
          !!error,
          <>
            <Flex flexDirection="column" w={334}>
              <Flex flexDirection="column">
                <H
                  bold
                  sm
                  color={theme.colors.n90}
                  as={4}
                >{tExpired`welcomeHeader`}</H>
                <Text
                  color={theme.colors.n70}
                >{tExpired`welcomeSubHeader`}</Text>
              </Flex>
            </Flex>
            <Flex>
              <InvitationExpiredForm />
            </Flex>
          </>,
          <>
            <Flex flexDirection="column" w={334}>
              <Flex flexDirection="column">
                <H
                  bold
                  sm
                  color={theme.colors.n90}
                  as={4}
                >{t`welcomeHeader`}</H>
                <Text color={theme.colors.n70}>{t`welcomeSubHeader`}</Text>
              </Flex>
            </Flex>
            <Flex>
              <FormProvider fieldsList={FormFieldsList}>
                <SignUpForm
                  code={code}
                  account={data?.getAccountBySignUpVerificationCode}
                />
              </FormProvider>
            </Flex>
          </>
        )}
      </Flex>
    </AuthenticationPageLayout>
  );
}

export default SignUpPage;
